import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { Mail, MessageSquare } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../api/client';

const stageColor = (s) => s==='Buyer' ? 'border-emerald-600 text-emerald-400' : s==='Lead' ? 'border-amber-600 text-amber-400' : 'border-zinc-700 text-zinc-400';

const AdminCRM = () => {
  const [q, setQ] = useState('');
  const [tab, setTab] = useState('all');
  const [list, setList] = useState([]);

  useEffect(() => {
    const stage = tab === 'all' ? '' : tab.charAt(0).toUpperCase() + tab.slice(1);
    api.listCustomers({ stage, q }).then(setList).catch(() => setList([]));
  }, [tab, q]);

  return (
    <div className="space-y-6">
      <p className="text-zinc-400 text-sm">Track every contact from <span className="text-[#d4af37]">Visitor</span> → <span className="text-[#d4af37]">Lead</span> → <span className="text-[#d4af37]">Buyer</span>. Tag, segment, email, and convert.</p>

      <Tabs value={tab} onValueChange={setTab}>
        <div className="flex flex-wrap gap-3 items-center">
          <TabsList className="bg-zinc-900">
            <TabsTrigger value="all">All</TabsTrigger>
            <TabsTrigger value="visitor">Visitors</TabsTrigger>
            <TabsTrigger value="lead">Leads</TabsTrigger>
            <TabsTrigger value="buyer">Buyers</TabsTrigger>
          </TabsList>
          <Input placeholder="Search name or email" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs bg-transparent border-zinc-800" />
        </div>
        <TabsContent value={tab} className="mt-6">
          <Card className="bg-zinc-950 border-zinc-900 overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-zinc-900/60"><tr className="text-left text-zinc-400"><th className="p-3">Name</th><th className="p-3">Stage</th><th className="p-3">Orders</th><th className="p-3">LTV</th><th className="p-3">Last seen</th><th className="p-3">Country</th><th className="p-3">Tags</th><th className="p-3 text-right">Actions</th></tr></thead>
              <tbody>
                {list.length === 0 && <tr><td colSpan={8} className="p-6 text-center text-zinc-500">No contacts in this segment yet</td></tr>}
                {list.map((c) => (
                  <tr key={c.id} className="border-t border-zinc-900 hover:bg-zinc-900/30">
                    <td className="p-3"><p className="text-zinc-100">{c.name}</p><p className="text-zinc-500 text-xs">{c.email}</p></td>
                    <td className="p-3"><Badge variant="outline" className={stageColor(c.stage)}>{c.stage}</Badge></td>
                    <td className="p-3 text-zinc-300">{c.orders_count}</td>
                    <td className="p-3 text-[#d4af37]">€{Number(c.ltv||0).toFixed(0)}</td>
                    <td className="p-3 text-zinc-300">{(c.last_seen||'').slice(0,10)}</td>
                    <td className="p-3 text-zinc-300">{c.country || '—'}</td>
                    <td className="p-3"><div className="flex flex-wrap gap-1">{(c.tags||[]).map((t) => <Badge key={t} variant="outline" className="border-zinc-800 text-zinc-300 text-xs">{t}</Badge>)}</div></td>
                    <td className="p-3 text-right">
                      <Button size="sm" variant="ghost" onClick={() => toast.success('Email composed (mock)')} className="text-zinc-300 hover:text-[#d4af37]"><Mail className="h-4 w-4" /></Button>
                      <Button size="sm" variant="ghost" onClick={() => toast.success('SMS sent (mock)')} className="text-zinc-300 hover:text-[#d4af37]"><MessageSquare className="h-4 w-4" /></Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </TabsContent>
      </Tabs>

      <Card className="bg-zinc-950 border-zinc-900 p-6">
        <h3 className="serif-italic text-[#d4af37] text-xl mb-2">Smart automations (coming online when you connect your email/SMS providers)</h3>
        <ul className="text-zinc-400 text-sm space-y-1 list-disc list-inside">
          <li>Cart-abandonment recovery 1h / 24h / 72h</li>
          <li>First-purchase 10% off welcome flow</li>
          <li>VIP segment when LTV ≥ €500</li>
          <li>Geo-bounced visitor capture (lead magnet)</li>
        </ul>
      </Card>
    </div>
  );
};

export default AdminCRM;
